import React from 'react';
import { chain } from 'lodash';
import { Card, CardHeader, CardBody, CardTitle } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AssessmentGroup, GoalSet, Loading, Icon } from 'js/components';
import { isArchived } from 'js/utils/team-utils';
import { Alert } from 'react-bs-notifier';
import styles from './TeamDashboardComponent.module.scss';
import { faClipboardListCheck } from '@fortawesome/pro-light-svg-icons';

function TeamActivityView({
  team = null,
  goals = [],
  assessments = [],
  onSetPrimary = () => {},
  onToggleAssessmentLock = () => {},
  onDeleteAssessment = () => {},
  onCopyLink = () => {},
}) {
  const hasAssessments = assessments && assessments.length > 0;

  if (!team) {
    return null;
  }

  return (
    <div className={styles.TeamInfo}>
      {isArchived(team) && (
        <Alert color="warning" type="warning" full-width>
          This team is currently{' '}
          <span className={styles.ArchiveState}>
            {team.archived_state?.toUpperCase()}
          </span>
          . You will not be able to make edits or create assessments for this
          team.
        </Alert>
      )}

      <div style={{ display: 'none' }}>
        {team.id !== undefined ? (
          <GoalSet entity={team} goals={goals} onSetPrimary={onSetPrimary} />
        ) : (
          <Loading />
        )}
      </div>

      <Card>
        <CardHeader>
          {hasAssessments && (
            <div className="action-items">
              <Link
                className="btn btn-primary"
                to={`/w/${team.workspace_id}/teams/${team.id}/assessments/new`}
                disabled={isArchived(team)}
              >
                <Icon
                  icon={['far', 'poll']}
                  size="lg"
                  className="btn-icon-left"
                />
                Assess
              </Link>
            </div>
          )}
          <CardTitle tag="h5">Assessments</CardTitle>
        </CardHeader>
        <CardBody>
          {!hasAssessments ? (
            <div className="media text-muted">
              <Icon
                icon={faClipboardListCheck}
                size="4x"
                className="mr-3"
                fixedWidth
              />
              <div className="media-body">
                <p>You haven't run any assessments for this team yet.</p>
                <Link
                  className="btn btn-primary"
                  to={`/w/${team.workspace_id}/teams/${team.id}/assessments/new`}
                  disabled={isArchived(team)}
                >
                  <Icon
                    icon={['far', 'poll']}
                    size="lg"
                    className="btn-icon-left"
                  />
                  Run an assessment now
                </Link>
              </div>
            </div>
          ) : (
            chain(assessments)
              .groupBy('key')
              .map((assessmentList, key) => {
                const name = assessmentList[0].name;
                return (
                  <AssessmentGroup
                    team={team}
                    workspaceId={team.workspace_id}
                    key={key}
                    templateId={key}
                    name={name}
                    assessments={assessmentList}
                    onToggleAssessmentLock={onToggleAssessmentLock}
                    onDeleteAssessment={onDeleteAssessment}
                    onCopyLink={onCopyLink}
                  />
                );
              })
              .value()
          )}
        </CardBody>
      </Card>
    </div>
  );
}

export default TeamActivityView;
